/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { workScheduleScheduleSchema } from "./workScheduleScheduleSchema.ts";

export const comboScheduleSchema = workScheduleScheduleSchema.describe("Расписание показа комбо в формате графика работы точки.");
